export default __webpack_public_path__ + "static/cafe_36030-966f207ea86adffa0e9e675040987f5e.png";